import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint, allpeepPayloadProgressObserverEndpoint, } from './helpers.js';
export const media = (rawClient, eventSource) => ({
    list: allpeepNoPayloadEndpoint(rawClient, '/media'),
    findById: allpeepNoPayloadEndpoint(rawClient, '/media/:id'),
    create: allpeepPayloadEndpoint(rawClient, '/media', 'post', true),
    /**
     * Same as `create` but routes through XHR so callers can pass
     * `onUploadProgress` to receive byte-level upload events. Returns either a
     * fully-processed `MediaAttachment` (small files, sync path) or a partial
     * one with `status: 'processing'` (large files, async path) — pair with
     * `progress.listen` to track the background processing phase.
     */
    createWithProgress: allpeepPayloadProgressObserverEndpoint(rawClient, '/media', 'post', true),
    delete: allpeepNoPayloadEndpoint(rawClient, '/media/:id', 'delete'),
    progress: {
        listen: eventSource('/media/:id/progress'),
    },
});
